var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labels"},_vm._l((_vm.labelData.list),function($i){return _c('Button',{directives:[{name:"auth",rawName:"v-auth",value:($i.authCode),expression:"$i.authCode"}],key:$i.label,class:_vm.on == $i.label? 'on' : '',attrs:{"type":"default"},on:{"click":function($event){return _vm.change($i)}}},[_vm._v(" "+_vm._s($i.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }